<template>
  <div class="layoutNav" :class="{ disabled: !isDisabled }">
    <template v-if="props.isReady">
      <div class="overflow" id="guideNav">
        <el-menu :default-active="tagCurrent" class="el-menu-vertical-demo" router :background-color="less.navBg" :text-color="less.navText" :active-text-color="less.navActiveText">
          <el-menu-item v-for="item in items.filter((n) => !n.isHide)" :key="item.title" :index="item.name" :route="`${item.path}/${$route.params.id}`">
            <el-icon>
              <i class="iconfont" v-html="item.icon"></i>
            </el-icon>
            <template #title>
              <el-badge :is-dot="Boolean(badgeDot && item.dot)" :value="item.dot" :hidden="item.dot == 0">
                {{ item.title }}
              </el-badge>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="btn">
        <div id="guideEnter">
          <el-button :loading="loading" @click="onClickEnter">进入企业</el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ACCESS } from "@/api/common/commonLimit";
import useCurrent from "@/hooks/useCurrent";
import useInitData from "@/hooks/useInitData";
import { computed, ref, nextTick } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import commonApi from "@/api/common/commonApi";
import less from "../styles/base.module.less";

const store = useStore();
const route = useRoute();
const { items, isDisabled } = useCurrent();
const { getCurrentToken } = useInitData();
const badgeDot = store.state.common.badgeDot;

const props = withDefaults(defineProps<{ isReady: boolean }>(), {
  isReady: false,
});

let username = computed((): string => store.getters.getUserinfo("realname"));
let tagCurrent = computed(() => store.state.tag.tagCurrent.name);
const loading = ref<boolean>(false);
const onClickEnter = async () => {
  const { access_token } = store.getters.getTagCurrentData;
  const thisCompany = store.getters.getThisCompany;

  console.log(store.getters, "store.getters");

  const id = route.params.id as string;
  try {
    loading.value = true;
    if (id) await getCurrentToken(id, ACCESS.ONE);
    const url = `${import.meta.env.VITE_APP_UNIFY_BASE_URL}?token=${access_token}&activeSubId=${thisCompany.subId}`;
    window.open(url);
  } finally {
    loading.value = false;
  }
};
</script>

<style lang="less" scoped>
.layoutNav {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: @navBg;
  .admin {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    min-height: 144px;
    background: #333f56;
    .avatar {
      width: 50px;
      height: 50px;
      background-color: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 27px;
        margin-top: 3px;
      }
    }
    .name {
      margin-top: 20px;
      color: #f5f6f7;
      font-size: 15px;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 80%;
      overflow: hidden;
      text-align: center;
    }
  }
  .overflow {
    overflow: auto;
    flex: 1;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .btn {
    box-shadow: 0px -4px 4px 0px #333f56;
    z-index: 1;
    display: flex;
  }
  #guideEnter {
    flex: 1;
    margin: 20px 15px;
    display: flex;
  }
  .el-button {
    flex: 1;
    background: transparent;
    color: @activeColor;
    border-color: @activeColor;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    min-height: 400px;
    height: 100%;
    font-size: 14px;
    overflow: hidden;
    border: none;
    .el-menu-item {
      padding-left: 20px;
    }
    .el-menu-item.is-active {
      background-color: var(--el-menu-hover-bg-color);
    }
    :deep(.el-badge__content.is-fixed) {
      right: 0;
      --el-transition-duration: 0;
    }
  }
}
.disabled {
  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    // z-index: 1;
  }
}
</style>
